import type { Auth0UserLike, RegionalUserLike } from '../../types/auth0-user.type'

import { getEmail } from './getEmail'
import { getFirstName } from './getFirstName'
import { getLastName } from './getLastName'

export function extractUserNames(
  auth0User: Auth0UserLike,
  regionalData?: RegionalUserLike | null
): {
  email: string
  firstName: string
  lastName: string
} {
  const email = getEmail(auth0User, regionalData)
  const firstName = getFirstName(auth0User, email, regionalData)
  const lastName = getLastName(auth0User, firstName, regionalData)

  return {
    email,
    firstName,
    lastName,
  }
}
